import { updateIntegrationToolParamsSchema } from "@redotech/redo-model/agents/platform-agents/settings/integration";
import { AiChatContext } from "@redotech/redo-web/ai/chat/contexts/ai-chat-context";
import { ToolComponentProps } from "@redotech/redo-web/ai/chat/types/tool-component-props";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { useContext, useMemo, useState } from "react";
import { ReturnsBlueYonderIntegration } from "../../../../setting/channel/blue-yonder";

export function UpdateIntegrationTool(props: ToolComponentProps) {
  const { sendToolResponse } = useContext(AiChatContext);

  const [submitted, setSubmitted] = useState(false);
  const [cancelled, setCancelled] = useState(false);

  const integration = useMemo(() => {
    if (props.input) {
      const result = updateIntegrationToolParamsSchema.safeParse(props.input);
      if (result.success) {
        return result.data;
      }
    }
    return undefined;
  }, [props.input]);

  if (cancelled) {
    return <Text>Integration setup cancelled</Text>;
  }

  if (submitted) {
    return <Text>Successfully updated integration</Text>;
  }
  if (integration?.type === "BlueYonder") {
    return (
      <Flex dir="column" gap="md" w="2xl">
        <ReturnsBlueYonderIntegration
          onSubmit={({ aiSuccessMessage }) => {
            setSubmitted(true);
            void sendToolResponse({
              toolCallId: props.toolCallId,
              toolName: props.toolName,
              result: { output: aiSuccessMessage },
            });
          }}
        />
        <Flex align="flex-start">
          <RedoButton
            hierarchy="tertiary"
            onClick={() => {
              setCancelled(true);
              void sendToolResponse({
                toolCallId: props.toolCallId,
                toolName: props.toolName,
                result: { output: "User cancelled the integration setup" },
              });
            }}
            size="sm"
            text="Cancel"
          />
        </Flex>
      </Flex>
    );
  }

  throw new Error(`Unknown integration: ${integration}`);
}
